type Props = React.HTMLProps<HTMLInputElement>

export default function BoxInput({ className, ...otherProps }: Props) {
  return <input
    className={`
        ${className} outline-0 border-1 border-dpGray placeholder-dpGreen
        px-4 py-2 rounded-lg shadow-inner-lg
    `}
    {...otherProps}
  />;
}